var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSparkle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79176 1.66675C5.36706 1.66675 5.83343 2.13312 5.83343 2.70842V3.75009H6.8751C7.4504 3.75009 7.91677 4.21646 7.91677 4.79176C7.91677 5.36706 7.4504 5.83343 6.8751 5.83343H5.83343V6.8751C5.83343 7.4504 5.36706 7.91677 4.79176 7.91677C4.21646 7.91677 3.75009 7.4504 3.75009 6.8751V5.83343H2.70842C2.13312 5.83343 1.66675 5.36706 1.66675 4.79176C1.66675 4.21646 2.13312 3.75009 2.70842 3.75009H3.75009V2.70842C3.75009 2.13312 4.21646 1.66675 4.79176 1.66675ZM4.79176 12.0834C5.36706 12.0834 5.83343 12.5498 5.83343 13.1251V14.1668H6.8751C7.4504 14.1668 7.91677 14.6332 7.91677 15.2085C7.91677 15.7838 7.4504 16.2501 6.8751 16.2501H5.83343V17.2918C5.83343 17.8671 5.36706 18.3335 4.79176 18.3335C4.21646 18.3335 3.75009 17.8671 3.75009 17.2918V16.2501H2.70842C2.13312 16.2501 1.66675 15.7838 1.66675 15.2085C1.66675 14.6332 2.13312 14.1668 2.70842 14.1668H3.75009V13.1251C3.75009 12.5498 4.21646 12.0834 4.79176 12.0834Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0834 1.66675C12.556 1.66675 12.9694 1.98496 13.0904 2.44186L14.3187 7.08232L17.8123 9.09783C18.1347 9.28386 18.3334 9.62783 18.3334 10.0001C18.3334 10.3724 18.1347 10.7164 17.8123 10.9024L14.3187 12.9179L13.0904 17.5584C12.9694 18.0153 12.556 18.3335 12.0834 18.3335C11.6108 18.3335 11.1974 18.0153 11.0764 17.5584L9.84805 12.9179L6.35455 10.9024C6.03209 10.7163 5.83343 10.3724 5.83343 10.0001C5.83343 9.62784 6.03209 9.28386 6.35455 9.09783L9.84805 7.08232L11.0764 2.44186C11.1974 1.98496 11.6108 1.66675 12.0834 1.66675Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSparkle);
export default __webpack_public_path__ + "static/media/dark-sparkle.6d0eb95d2f59fea9b864335d18473a9b.svg";
export { ForwardRef as ReactComponent };